import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translation'
})
export class TranslationPipe implements PipeTransform {

  transform(term: string, mapper: TermMapper | object): string {
    const separatedTerm = this.separateDigits(term);
    if (typeof mapper === 'function') {
      return mapper(separatedTerm[0]);
    }
    separatedTerm[0] = stringMapper(separatedTerm[0], mapper);
    return separatedTerm.join('');
  }

  private separateDigits(term: string): string[] {
    const num = term.match(/\s\d+/) ?? [''];
    return [
      term.replace(num[0], ''),
      num[0]
    ];
  }

}

export type TermMapper = (term: string) => string;

export function stringMapper(term: string, obj: object): string {
  return obj[term] ?? term;
}

export const UNITS = {
  unit: $localize`unit`,
  meter: $localize`meter`
};
